// src/composables/useAlert.js
import { ref } from 'vue'

export function useAlert(timeout = 4000) {
    const alertMessage = ref('')
    const alertType = ref('success') // 'success' | 'error' | 'info' | 'warning'
    const showAlert = ref(false)

    const showAlertMessage = (message, type = 'success') => {
        alertMessage.value = message
        alertType.value = type
        showAlert.value = true

        setTimeout(() => {
            showAlert.value = false
        }, timeout)
    }

    return {
        alertMessage,
        alertType,
        showAlert,
        showAlertMessage
    }
}
